import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { PointWithdrawalType } from "@roman/shared/types/PointWithdrawal";
import { useEffect } from "react";
import type { Key } from "swr";
import useSWRMutation from "swr/mutation";

type WithdrawalArg = {
  type: PointWithdrawalType;
  redeemablePoints: string;
};

type WithdrawalSuccessResponse = string;

const postPointWithdrawalRequest = async (url: string, { arg }: { arg: WithdrawalArg }) => {
  const headers = authHeader.getOrThrow();
  return romanApi.post<WithdrawalSuccessResponse, WithdrawalArg>(url, arg, { headers });
};

export const usePostPointWithdrawalRequest = (handleError: (err: RomanApiError) => void) => {
  const { data, isMutating, trigger, error } = useSWRMutation<
    WithdrawalSuccessResponse,
    RomanApiError,
    Key,
    WithdrawalArg
  >("/point-withdrawals/withdrawal", postPointWithdrawalRequest);

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data,
    trigger,
    isMutating,
    isError: error !== undefined,
    error,
  };
};
